import { useMemo } from 'react';

/**
 * `locked` / `lockSources` are the server's maps keyed by step1…step6 (camelCase field → value/source).
 * Returns helpers scoped to one data step.
 */
export function useLocked(locked, lockSources, dataStep) {
  return useMemo(() => {
    const key = dataStep ? `step${dataStep}` : null;
    const values = (key && locked?.[key]) || {};
    const sources = (key && lockSources?.[key]) || {};
    return {
      isLocked: (field) => Object.prototype.hasOwnProperty.call(values, field),
      valueOf: (field) => values[field],
      sourceOf: (field) => sources[field] || 'gst',
      any: Object.keys(values).length > 0,
    };
  }, [locked, lockSources, dataStep]);
}

/** Every locked field key across all steps — used to drop client writes to locked values. */
export function allLockedKeys(locked) {
  return new Set(Object.values(locked || {}).flatMap((rec) => Object.keys(rec || {})));
}
